import { Component, forwardRef, Input } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { CodeEntry } from 'app/core/gb-api';
import { AuftragRechteSelectionMeta } from 'app/core/batch-auftrag-api';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { AtLeastOneValidatorDirective } from '../../validators/at-least-one-validator.directive';
import { CapFormControlComponent } from '../../../../../shared/form-control/form-control.component';
import { MetaDisablerDirective } from '../../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../../shared/directives/meta-validator.directive';
import { AuftragCodeSelectionComponent } from '../auftrag-code-selection/auftrag-code-selection.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-auftrag-rechte-selection',
  templateUrl: './auftrag-rechte-selection.component.html',
  styleUrls: ['./auftrag-rechte-selection.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AuftragRechteSelectionComponent),
      multi: true
    }
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: NgForm
    }
  ],
  imports: [
    AtLeastOneValidatorDirective,
    FormsModule,
    CapFormControlComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    AuftragCodeSelectionComponent,
    TranslatePipe
  ]
})
export class AuftragRechteSelectionComponent implements ControlValueAccessor {
  capiCodeTypes: CodeEntry.TypeEnum[] = ['ANMERKUNG', 'VORMERKUNG', 'DIENSTBARKEIT_GRUNDLAST', 'GRUNDSTUECK_UNTER_ART_SDR'];

  @Input()
  heading = 'Rechtart';

  @Input()
  disabled: boolean;

  model: AuftragRechteSelectionMeta = <AuftragRechteSelectionMeta>{};

  propagateChange: (id: string) => void;
  propagateTouch: (_) => void;

  constructor() {
    keysToTranslate([
      'EingabeMussMindestensEineRechteArtAusgewaehltHaben', // same name as ngModelGroup of template
      'Rechtart'
    ]);
  }

  writeValue(obj: any): void {
    this.model = obj;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  get types(): CodeEntry.TypeEnum[] {
    if (this.model) {
      const types = [];
      if (this.model.sucheDienstbarkeit || this.model.sucheGrundlast) {
        types.push('DIENSTBARKEIT_GRUNDLAST');
      }
      if (this.model.sucheVormerkung) {
        types.push('VORMERKUNG');
      }
      if (this.model.sucheAnmerkung) {
        types.push('ANMERKUNG');
      }
      if (this.model.sucheSDR) {
        types.push('GRUNDSTUECK_UNTER_ART_SDR');
      }

      return types;
    }
    return [];
  }
}
